import React, { FunctionComponent, useState } from 'react'
import * as S from './styled'
import { ReactComponent as MenuIcon } from '../../atoms/Icons/dotdotdot.svg'
import { BoldText } from '../../../theme/typography'
import ActionMenu from '../../atoms/ActionMenu/ActionMenu'
import { useDispatch, useSelector } from 'react-redux'
import { requestActions } from '../../../redux/requests'
import { MainState } from '../../../redux/reducers'
import OutsideAlerter from '../../../hooks/OutsideAlerter'

type OwnProps = {
  email: string
  setWlState: any
}

type Props = OwnProps

const WhitelistCard: FunctionComponent<Props> = ({ email, setWlState }) => {
  const uid = useSelector((state: MainState) => state.misc.uid)

  const [showMenu, setShowMenu] = useState(false)

  const dispatch = useDispatch()
  const clickHandler = (option: string) => {
    if (option === 'remove') {
      dispatch(requestActions.products.deleteWhitelistItem(uid!, email))
      setWlState(prevState => prevState.filter(item => item !== email))
    }
  }

  return (
    <>
      <S.ListCard>
        <BoldText>{email}</BoldText>

        {showMenu && (
          <OutsideAlerter setShowMenu={setShowMenu}>
            <ActionMenu
              options={[{ func: 'remove', name: 'Ta bort' }]}
              clickHandler={(option: string) => clickHandler(option)}
            />
          </OutsideAlerter>
        )}
        <S.Button className="hide" onClick={() => setShowMenu(!showMenu)} listView>
          <MenuIcon />
        </S.Button>
      </S.ListCard>

      {/* <S.CardMobile>
        {showMenu && (
          <OutsideAlerter setShowMenu={setShowMenu}>
            <ActionMenu clickHandler={(option: string) => clickHandler(option)} />
          </OutsideAlerter>
        )}
        <S.Button className="hide" onClick={() => setShowMenu(!showMenu)}>
          <MenuIcon />
        </S.Button>
        <PdfIcon />
        <NavLink to={PageRoute.DOCUMENTS + '/' + doc.id} exact>
          <BoldText>{doc.fileName}</BoldText>
        </NavLink>
        <BoldText fontSize={'12px'}>datum: {doc.settlementDate}</BoldText>
        <BoldText fontSize={'12px'}>uppladdat av: {doc.uploadedBy}</BoldText>
      </S.CardMobile> */}
    </>
  )
}
export default WhitelistCard
